import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircle } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-screen flex items-center pt-32 pb-20 overflow-hidden bg-ink" data-id="element-91">
      {/* Ultra-premium architectural background */}
      <div className="absolute inset-0 z-0" data-id="element-92">
        <img src="https://cdn.magicpatterns.com/uploads/aDAXFqEKdWDQxSN4cV7bYm/ChatGPT_Image_Jun_12,_2026,_01_27_34_PM.png" alt="Luxury modern kitchen and dining interior with marble island and fireplace" className="w-full h-full object-cover object-center md:object-[55%_center]" data-id="element-93" />
        {/* Horizontal overlay: stronger on the left for headline contrast, lighter on the right to reveal the architecture */}
        <div className="absolute inset-0" style={{
        background: 'linear-gradient(90deg, rgba(0,0,0,0.72) 0%, rgba(0,0,0,0.52) 40%, rgba(0,0,0,0.25) 70%, rgba(0,0,0,0.12) 100%)'
      }} data-id="element-94"></div>
        {/* Subtle vertical overlay for top/bottom legibility */}
        <div className="absolute inset-0" style={{
        background: 'linear-gradient(180deg, rgba(0,0,0,0.28) 0%, rgba(0,0,0,0.12) 45%, rgba(0,0,0,0.45) 100%)'
      }} data-id="element-95"></div>
      </div>

      <div className="container mx-auto px-8 lg:px-12 relative z-10" data-id="element-96">
        <div className="max-w-4xl" data-id="element-97">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="flex items-center gap-4 mb-8" data-id="element-98">
            <div className="w-8 h-[1px] bg-lime" data-id="element-99"></div>
            <span className="text-paper/80 font-body text-xs uppercase tracking-[0.3em]" data-id="element-100">
              Clean Spaces. Zero Drama.
            </span>
          </motion.div>

          <motion.h1 className="text-5xl md:text-7xl lg:text-8xl text-paper leading-[1.1] mb-8 font-light" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.1,
          ease: 'easeOut'
        }} data-id="element-101">
            Professional Cleaning in <br className="hidden md:block" data-id="element-102" />
            <span className="font-medium" data-id="element-103">Orlando & Kissimmee</span>
          </motion.h1>

          <motion.p className="text-lg md:text-xl text-concrete/90 font-light mb-12 max-w-2xl tracking-wide" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2,
          ease: 'easeOut'
        }} data-id="element-104">
            We don't clean.{' '}
            <span className="text-paper font-normal" data-id="element-105">We reset spaces.</span>
          </motion.p>

          <motion.div className="flex flex-col sm:flex-row gap-6" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.3,
          ease: 'easeOut'
        }} data-id="element-106">
            <a href="#quote" className="bg-paper text-ink px-8 py-4 text-xs uppercase tracking-[0.2em] hover:bg-concrete transition-colors text-center flex items-center justify-center" data-id="element-107">
              Get a Free Quote
            </a>

            <a href="https://wa.me/19545498931" target="_blank" rel="noopener noreferrer" className="border border-paper/30 text-paper px-8 py-4 text-xs uppercase tracking-[0.2em] hover:bg-paper/10 transition-colors text-center flex items-center justify-center gap-3 group" data-id="element-108">
              <MessageCircle size={16} className="text-lime group-hover:scale-110 transition-transform" strokeWidth={1.5} data-id="element-109" />
              <span data-id="element-110">Text Us on WhatsApp</span>
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}